export const scopes = [
  "user-read-private",
  "user-read-playback-state",
  "user-modify-playback-state"
];
